import CharacterRole from './CharacterRole'

export const simpleCharacterRoles = ['heal', 'tank', 'damage'] as const

export const roleToSimpleRole = (role: CharacterRole) =>
  ({
    tank: 'tank',
    heal: 'heal',
    melee: 'damage',
    ranged: 'damage',
  }[role])

type SimpleCharacterRole = typeof simpleCharacterRoles[number]
export default SimpleCharacterRole
